
export default {
  RECIPE_GROUP_INIT: 'RECIPE_GROUP_INIT',
  RECIPE_GROUP_COURSE: 'RECIPE_GROUP_COURSE',
  RECIPE_GROUP_CUISINE: 'RECIPE_GROUP_CUISINE',
  RECIPE_GROUP_TAG: 'RECIPE_GROUP_TAG',
};


// WEBPACK FOOTER //
// ./modules/recipe_form/constants/RecipeGroupConstants.js